// Single source of truth for Datadog RUM env vars in this repo.
// Read VITE_DATADOG_* here, nowhere else.

export interface DatadogEnv {
  applicationId: string;
  clientToken: string;
  env: string;
  service: string;
  site: string;
  version: string | undefined;
}

const PLACEHOLDER_RE = /^(?:<.*>|.*_replace_me)$/;

function cleanEnvValue(value: string | undefined): string | null {
  const cleaned = value?.trim();
  if (!cleaned || PLACEHOLDER_RE.test(cleaned)) {
    return null;
  }
  return cleaned;
}

/** Reads the optional Datadog RUM browser configuration from Vite env. */
export function getDatadogEnv(): DatadogEnv | null {
  const applicationId = cleanEnvValue(import.meta.env.VITE_DATADOG_APPLICATION_ID);
  const clientToken = cleanEnvValue(import.meta.env.VITE_DATADOG_CLIENT_TOKEN);
  if (!(applicationId && clientToken)) {
    return null;
  }
  return {
    applicationId,
    clientToken,
    site: cleanEnvValue(import.meta.env.VITE_DATADOG_SITE) ?? "us5.datadoghq.com",
    service: cleanEnvValue(import.meta.env.VITE_DATADOG_SERVICE) ?? "xan-business",
    env: import.meta.env.MODE,
    version: cleanEnvValue(import.meta.env.VITE_APP_VERSION) ?? undefined,
  };
}
